import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from "@aws-amplify/ui-react";
import { Amplify } from 'aws-amplify';

// aws-amplify v6: configure once from the Gen 2 backend outputs (data=apiKey + geo).
// No Cognito/DataStore — the app has no logins and uses generateClient (see apiClient.js).
import outputs from './amplify_outputs.json';

import "@aws-amplify/ui-react/styles.css";
import { studioTheme } from "./ui-components";
import {
  BrowserRouter
} from 'react-router-dom';

Amplify.configure(outputs);

const root = ReactDOM.createRoot(document.getElementById('root'));
<base href="/" />
root.render(
  // <React.StrictMode>
  // v6 ui-react: AmplifyProvider was removed; ThemeProvider is the wrapper now.
  <ThemeProvider theme={studioTheme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
